<template>
  <div class="two" :class="{'gudingo':guding}" :style="{top:mtop}" id="yuanshu1">
    <div class="T_title0" v-if="showtype!='collegescore'&&showtype!='majorscore'" style="width: 90px;">风险系数</div>
    <div class="T_title1" style="width: 300px;">招生院校</div>
    <div class="T_title2" :style="{width:showtype=='collegescore'||showtype=='majorscore'?'300px':'300px'}">招生专业</div>
    <div class="T_title4" style="width: 70px;">{{jhYear}}</div>
    <div style="width: 430px;justify-content: start; flex-direction: row;display: flex;" >
      <div class="T_title5" :style="{width: listw[0]}">年份</div>
      <div class="T_title5" :style="{width: listw[1]}">计划/录取</div>
      <div class="T_title5" :style="{width: listw[2]}">最低</div>
      <div class="T_title5" :style="{width: listw[3]}" v-if="showflag">等效</div>
      <div class="T_title5" :style="{width: listw[4]}" style="display: flex;
      align-items: center;
      flex-direction: row;">等位
      <el-tooltip effect="dark" placement="bottom">
        <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
          等位分：把往年院校或专业录取原始成绩，转换为最新一年和原始成绩对应位次相同的分数，考生可直接参考等位分和自己高考成绩对比，看是否能达到院校录取标准。
        </div>
        <div class="topclass">?</div>
        </el-tooltip>
      </div>
      <div class="T_title5" :style="{width: listw[5]}">位次</div>
      <div class="T_title5" :style="{width: listw[6]}" style="justify-content: center;display: flex;
      align-items: center;
      flex-direction: row;">分差/位差
      <el-tooltip effect="dark" placement="bottom">
        <div style="height: auto;width: auto; max-width: 350px;color: #ffffff;" slot="content">
          分差：考生成绩与院校或专业录取等位分的分差，分差为正说明考生成绩高于录取成绩，分差为负说明考生成绩低于录取成绩
          <br/>
          <br/>
          位差：院校或专业录分对应位次与考生位次的差，位差为正说明考生位次高于录取位次，位差为负说明考生位次低于录取位次
        </div>
        <div class="topclass">?</div>
        </el-tooltip>
      </div>
    </div>


    <!-- <div class="T_title6" :style="{width:rlist[6]+'%'}" v-if="tianbaoType !=0" >{{tianbaoType ==1||showtype == 'majorscore'?"专业":"分组"}}</div>
    <div class="T_title10" :style="{width:rlist[10]+'%'}" v-if="tianbaoType !=0">选科</div>
    <div class="T_title11" :style="{width:rlist[6]+'%'}" v-if="tianbaoType ==0">专业</div>
    <div class="T_title7" :style="{width:rlist[7]+'%'}">招生</div>
    <div class="T_title8" :style="{width:rlist[8]+'%'}">
      <div class="T_title8top">近年录取统计</div>
      <div class="T_title8bot">
        <div>年份</div>
        <div>录取数</div>
        <div>最低分</div>
        <div v-if="role>=2">等效分</div>
        <div  v-if="role>=2">等位分</div>
        <div>位次</div>
        <div>线差</div>
      </div>
    </div> -->
    <div class="T_title9" :style="{width:showtype!='collegescore'&&showtype!='majorscore'?'88px':'168px'}" >操作</div>
  </div>
</template>

<script>
  export default {
    props:{
      guding:{
        type:Boolean
      },
      showtype:{
        type:String
      },
      jhYear:{
        type:Number,
        defaule:null
      },
    },
    watch:{
      guding(va){
        if(va){this.gettop()}
      },
      showtype(va){
        //this.rlist = this.$utils.getHeardrList(this.tianbaoType,va)
      }
    },
    data(){
      return {
        rlist:[],
        showflag:false,
        listw:['50px','70px','50px','50px','50px','100px','60px'],
        tianbaoType: this.$utils.getlocalStorage('tianbaoType'),
        mtop:'135px',
        role: parseInt(this.$utils.getlocalStorage("userInfo").userRole),
      }

    },
    methods:{
      gettop(){
        console.log()
        if(this.showtype != 'tb'){
          this.mtop =  '70px'
        } else {
          if(this.tianbaoType == 0){
            this.mtop =  '130px';
          } else {
            this.mtop =  '155px';
          }
        }
        if(this.showflag){
          this.listw = ['50px','70px','50px','50px','50px','60px','100px']
        } else {
          this.listw = ['60px','75px','50px','0px','60px','70px','105px']
        }
      }
    },
    created() {
      this.showflag = this.role==3||this.role==2
      this.gettop();
      this.rlist = this.$utils.getHeardrList(this.tianbaoType,this.showtype)
      console.log(this.rlist)
    }
  }
</script>

<style scoped>
  .gudingo {
      position: fixed;
      top: 135px;
      left: ;
      -webkit-transform: translate(0);
      transform: translate(0);
      margin-top: 0 !important;
      width: 1280px !important;
      z-index: 1;
  }
  .gudingo div {
    flex-shrink: 0;
  }
  .topclass{
    width: 16px;
    height: 16px;
    border: white solid 1px;
    border-radius: 10px;
    line-height: 14px;
    margin-left: 5px;
    font-size: 12px;
  }

  /* 表格表头 */
  .two {
    display: flex;
    width: 1280px;
    height: 45px;
    background-color: #f66464;
    margin-top: 10px;
    border-radius: 2px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    line-height: 50px;
    color: #ffffff;
    justify-content: start;
    align-items: center;
  }

  .two .T_title0 {
    width: 7%;
    text-align: center;
  }

  .two .T_title1 {
    width: 21%;
    text-align: center;
  }

  .two .T_title2 {
    width: 4%;
    text-align: center;
  }

  .two .T_title3 {
    width: 4%;
    text-align: center;
  }

  .two .T_title4 {
    width: 6%;
    text-align: center;
  }

  .two .T_title5 {
    width: 4%;
    text-align: center;
  }

  .two .T_title6 {
    width: 13%;
    text-align: center;
  }

  .two .T_title7 {
    width: 4%;
    text-align: center;
  }

  .two .T_title8 {
    width: 25%;
    text-align: center;
    display: flex;
    flex-direction: column;
    border-left: 1px solid rgba(255, 255, 255, 0.3);
    border-right: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8top {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.3);
  }

  .T_title8bot {
    height: 30px;
    display: flex;
    justify-content: space-evenly;
  }

  .T_title8bot div {
    line-height: 30px;
  }

  .two .T_title9 {
    width: 8%;
    text-align: center;
  }
  .two .T_title10 {
    width: 4%;
    text-align: center;
  }
  .two .T_title11 {
    width: 17%;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/tianbaoHeader/newgkmajorHeader.vue